import React from 'react';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import type { Value } from '@wojtekmaj/react-daterange-picker/dist/shared/types';

import '../../theme/dateRangePicker.css';

type NewDateRangePickerProps = React.PropsWithChildren<{
  value?: Value;
  onChange?: (value: Value) => void | undefined;
  minDate?: Date;
  maxDate?: Date;
}>;

export const NewDateRangePicker = (props: NewDateRangePickerProps) => {
  return (
    <div className="small-calendar">
      <DateRangePicker
        onChange={props.onChange}
        value={props.value}
        monthAriaLabel="Month"
        maxDetail="year"
        format="MM.yyyy"
        minDate={props.minDate}
        maxDate={props.maxDate}
        locale={'pl-PL'}
      />
    </div>
  );
};
